import { motion } from "framer-motion";
import {
  Code2,
  ShoppingCart,
  Fingerprint,
  PenTool,
  Shirt,
  Signpost,
  Gauge,
  Megaphone,
  CreditCard,
} from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { SERVICES } from "../data/content";

const ICONS = {
  "web-development": Code2,
  ecommerce: ShoppingCart,
  "brand-design": Fingerprint,
  "graphic-design": PenTool,
  embroidery: Shirt,
  "print-design": Signpost,
  "website-management": Gauge,
  "promotional-products": Megaphone,
  "business-cards": CreditCard,
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          testId="services-heading"
          eyebrow="What we do"
          title="Eight disciplines. One shop."
          description="Everything you need to be great online is already inside your business — we build it out. Custom web, design, branding and print, all under one roof."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6">
          {SERVICES.map((service, i) => {
            const Icon = ICONS[service.id];
            return (
              <motion.div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: "easeOut" }}
                whileHover={{ y: -4 }}
                className={`glass rounded-2xl p-7 md:p-8 flex flex-col justify-between gap-8 min-h-[220px] hover:border-signal/60 transition-colors duration-300 group ${service.span}`}
              >
                <div className="flex items-start justify-between">
                  <span className="grid place-items-center w-11 h-11 rounded-xl bg-signal/10 border border-signal/30 text-signal group-hover:neon-glow transition-shadow duration-300">
                    <Icon size={20} />
                  </span>
                  {service.featured && (
                    <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-signal/90 border border-signal/30 rounded-full px-3 py-1">
                      Core
                    </span>
                  )}
                </div>
                <div>
                  <h3 className="font-display text-2xl font-medium text-white">{service.title}</h3>
                  <p className="mt-2 text-muted text-sm md:text-base leading-relaxed">{service.blurb}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
